var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 1,
    fill: "#32373F",
    stroke: "#C2D1FC",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8.25,
    width: 5,
    height: 1.5,
    fill: "#C2D1FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11.25,
    width: 5,
    height: 1.5,
    fill: "#C2D1FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.25,
    width: 5,
    height: 1.5,
    fill: "#C2D1FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.25,
    width: 5,
    height: 1.5,
    fill: "#C2D1FC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11.25,
    width: 5,
    height: 1.5,
    fill: "#C2D1FC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14.25,
    width: 5,
    height: 1.5,
    fill: "#C2D1FC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 6,
    width: 1.5,
    height: 12,
    fill: "#C2D1FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedAsset);
export default __webpack_public_path__ + "static/media/fixed-asset.c049ef6c07f5fd8ca81c0e8cfbe3a00c.svg";
export { ForwardRef as ReactComponent };